import { createContext, useContext, useState, useMemo } from "react";
import Cookies from "js-cookie";
import { encryptData, decryptData } from "../utils/helpers";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const loadAuthFromCookies = () => {
    try {
      const token = Cookies.get("token") || null;
      const adminRaw = Cookies.get("admin_enc");
      const admin = adminRaw ? decryptData(adminRaw) : null;
      const sc_id = Cookies.get("sc_id") || "0";

      return { token, admin, sc_id };
    } catch (err) {
      console.error("Failed to load cookies:", err);
      return { token: null, admin: null, sc_id: "0" };
    }
  };

  const [auth, setAuth] = useState(loadAuthFromCookies);

  const login = (data) => {
    const scId = data.sc_id?.toString() || "0";
    const expiresAt = Date.now() + Number(data.expiresIn) * 1000;

    const adminSafe = {
      admin_id: data.admin_id,
      name: data.name,
      email: data.email,
      role: data.role || null,
      expiresIn: expiresAt,
    };

    const cookieOptions = {
      secure: true,
      sameSite: "Lax",
      path: "/",
      expires: 7,
    };

    Cookies.set("token", data.token, cookieOptions);
    Cookies.set("admin_enc", encryptData(adminSafe), cookieOptions);
    Cookies.set("sc_id", scId, cookieOptions);

    setAuth({ admin: adminSafe, token: data.token, sc_id: scId });
  };

  const logout = () => {
    Cookies.remove("token");
    Cookies.remove("admin_enc");
    Cookies.remove("sc_id");

    setAuth({ admin: null, token: null, sc_id: null });

    window.location.href = "/login"; // avoids react-router dependency
  };

  const value = useMemo(
    () => ({ auth, login, logout }),
    [auth] // prevents unnecessary rerenders
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
